export default class AcompanhamentoEntregaMateriaPrima {
  idAcompanhamentoSolicitacaoMateriaPrima: number;
  idSolicitacaoMateriaPrima: number;
  idEntregaVenda: number;  
  sku: number;
  descricao: string;
  centroOrigem: string;
  quantidade: number;
  dataEmbarque: Date;
  dataEntrega: Date;
  remessa: string;
  ocr: string;
  nf: string;
  placaCarreta: string;
  observacoes: string | null;
  laudo: string | Blob | null;
  d_E_L_E_T_E: boolean;
  excluidoEm: Date | string | null;
  criadoEm: Date | string | null;

  constructor(
    idAcompanhamentoSolicitacaoMateriaPrima: number,
    idSolicitacaoMateriaPrima: number,
    idEntregaVenda: number,
    sku: number,
    descricao: string,
    centroOrigem: string,
    quantidade: number,
    dataEmbarque: Date,
    dataEntrega: Date,
    remessa: string,
    ocr: string,
    nf: string,
    placaCarreta: string,
    observacoes: string,
    laudo: Blob,
    d_E_L_E_T_E: boolean,
    criadoEm: Date | string | null,
    excluidoEm: Date | string | null
  ) {
    this.idAcompanhamentoSolicitacaoMateriaPrima = idAcompanhamentoSolicitacaoMateriaPrima;
    this.idSolicitacaoMateriaPrima = idSolicitacaoMateriaPrima;
    this.idEntregaVenda = idEntregaVenda;
    this.sku = sku;
    this.descricao = descricao;
    this.centroOrigem = centroOrigem;
    this.quantidade = quantidade;
    this.dataEmbarque = dataEmbarque;
    this.dataEntrega = dataEntrega;
    this.remessa = remessa;
    this.ocr = ocr;
    this.nf = nf;
    this.placaCarreta = placaCarreta;
    this.observacoes = observacoes ?? "";
    this.laudo = laudo;
    this.d_E_L_E_T_E = d_E_L_E_T_E;
    this.criadoEm = criadoEm;
    this.excluidoEm = excluidoEm;
  }

  static toJson(
    acompanhamentoEntregaMateriaPrima: AcompanhamentoEntregaMateriaPrima
  ): string {
    return JSON.stringify(acompanhamentoEntregaMateriaPrima);
  }

  static fromJson(json: object[]): AcompanhamentoEntregaMateriaPrima[] {
    let acompanhamentoEntregaMateriaPrimaArr: AcompanhamentoEntregaMateriaPrima[] =
      [];
    json.forEach((item: any) => {
      acompanhamentoEntregaMateriaPrimaArr.push(
        new AcompanhamentoEntregaMateriaPrima(
          item["idAcompanhamentoSolicitacaoMateriaPrima"],
          item["idSolicitacaoMateriaPrima"],
          item["idEntregaVenda"],
          item["sku"],
          item["descricao"],
          item["centroOrigem"],
          item["quantidade"],
          new Date(item["dataEmbarque"]),
          new Date(item["dataEntrega"]),
          item["remessa"],
          item["ocr"],
          item["nf"],
          item["placaCarreta"],
          item["observacoes"],
          item["laudo"],
          item["d_E_L_E_T_E"],
          new Date(item["criadoEm"]),
          new Date(item["excluidoEm"])
        )
      );
    });
    return acompanhamentoEntregaMateriaPrimaArr;
  }
}
